import { FC } from 'react';
import { Redirect } from 'react-router-dom';

import useActivationOnboardingProgress from 'common/hooks/useActivationOnboardingProgress/useActivationOnboardingProgress';
import ErrorView from 'components/ErrorView';
import Loader from 'components/Loader';
import Stepper from 'components/Stepper';
import { StepOptions, StepProps } from 'components/Stepper/types';

import * as routes from '../../../../../routes';
import { useAutomaticVirtualCardOrder } from '../../hooks/useAutomaticVirtualCardOrder';
import AutomaticVirtualCardLoader from './steps/AutomaticVirtualCardLoader';
import FirstVirtualCardSummary from './steps/FirstVirtualCardSummary';

const PhysicalCardOrderSuccess: FC<StepProps> = () => {
  const { error, isPlanInsufficient, loading, shouldAutoOrderVirtualCard } =
    useAutomaticVirtualCardOrder({ fetchPolicy: 'network-only' });

  const { refetch: refetchActivationOnboardingProgress } =
    useActivationOnboardingProgress({ fetchPolicy: 'cache-only' });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorView />;
  }

  const steps: StepOptions[] = [];

  const addSteps = () => {
    if (shouldAutoOrderVirtualCard) {
      steps.push(
        {
          key: 'virtual-card-loader',
          render: (props) => <AutomaticVirtualCardLoader {...props} />,
        },
        {
          key: 'virtual-card-summary',
          render: (props) => (
            <FirstVirtualCardSummary
              doesPlanIncludeVCAutoOrder={true}
              {...props}
            />
          ),
        },
      );
      return;
    }

    if (isPlanInsufficient) {
      steps.push({
        key: 'virtual-card-summary',
        render: (props) => (
          <FirstVirtualCardSummary
            doesPlanIncludeVCAutoOrder={false}
            {...props}
          />
        ),
      });
    }
  };

  addSteps();

  if (steps.length !== 0) {
    return <Stepper steps={steps} />;
  } else {
    refetchActivationOnboardingProgress();
    return <Redirect to={routes.root} />;
  }
};

export default PhysicalCardOrderSuccess;
